/**
 * Parses a JSON string without throwing. Returns `fallback` on invalid input or parse errors.
 * @param {string|null|undefined} value
 * @param {*} fallback
 * @returns {*}
 */
export function safeJsonParse(value, fallback = null) {
  try {
    // JSON.parse("null") === null, so ?? treats it as missing and returns fallback.
    // This is intentional: no current call site stores a meaningful JSON null.
    return JSON.parse(value) ?? fallback;
  } catch {
    return fallback;
  }
}

/**
 * Serialises a value to JSON without throwing (e.g. circular references, BigInt).
 * Returns `fallback` on serialisation errors.
 * @param {*} value
 * @param {string} fallback
 * @returns {string}
 */
export function safeJsonStringify(value, fallback = '') {
  try {
    return JSON.stringify(value) ?? fallback;
  } catch {
    return fallback;
  }
}
